import React, { useRef } from 'react';
import { useDrop, useDrag } from 'react-dnd';
import { useTranslation } from 'react-i18next';
import { ElementTemplate } from '../../TemplateComponent';

function SFDetails({
  col,
  i,
  index,
  dropLocation,
  changePosition,
  dropInLocation,
  fromForm,
  duplicatingItem,
  editingInput,
  onChange,
  factoryData,
  eleIndex,
  deleteItem,
}) {
  const { t } = useTranslation('common');

  const ifNotContainer = (item, index, i) => {
    return item?.col ? changePosition(item, index, i) : dropInLocation(i, index, item, factoryData?.id);
  };
  const sfRef = useRef(null);
  const [{ item, handlerId, isOver }, drop] = useDrop({
    accept: ['container', 'item'],
    drop: () => {
      item.type === 'container' ? dropLocation(index, item) : ifNotContainer(item, index, i);
    },
    collect: (monitor) => ({
      item: monitor.getItem(),
      handlerId: monitor.getHandlerId(),
      isOver: monitor.isOver(),
    }),
  });
  const [{ isDragging }, drag] = useDrag({
    type: col?.type,
    item: () => {
      return { col, index, i };
    },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  });
  const opacity = isDragging ? 0 : 1;
  drag(drop(sfRef));

  return (
    <div ref={sfRef} style={{ opacity }} data-handler-id={handlerId} key={`${col?.label}_${index}_${i}`}>
      {isOver && <div className="potemplate-drag-placeholder">{t('PO_TEMPLATES.PO_DETAILS.FORM_COMPONENT.SF_DETAILS.DROP_SECTION_HERE')}</div>}
      <ElementTemplate
        {...col}
        keys={col?.key}
        error={col?.hasError}
        requiredField={col?.required}
        disable
        val
        options={col?.options}
        placeHolder={col?.placeholder ? `${col?.placeholder}` : `${col?.label}`}
        fromForm={fromForm}
        duplicatingItem={duplicatingItem}
        editingInput={editingInput}
        index={index}
        i={i}
        value={col?.value}
        onChange={onChange}
        id={col?.id}
        elekey={factoryData?.key}
        eleIndex={eleIndex}
        deleteItem={deleteItem}
        showDelete={col?.addingNew}
      />
    </div>
  );
}

export default SFDetails;
